module.exports = __webpack_public_path__ + "img/watch-calculator.8da89a8b.svg";